import type { SeoResolver } from '../types';

/** SEO for a selected registration (SRO) office. Moved verbatim from SEO.tsx. */
export const registrationSeoResolver: SeoResolver = (ctx) => {
  const office = ctx.selections.registrationOffice;
  if (!office) return null;

  const { siteName, layerName } = ctx;
  const p = office.properties;
  const sroTitle = p.sro_name || p.office_nam || 'Registration Office';
  const sroDesc = p.sro_name || p.office_nam || 'this registration office';

  return {
    title: `${sroTitle} | ${layerName} | ${siteName}`,
    description: `Explore jurisdictional boundaries for ${sroDesc} (SRO) in ${p.district || 'Tamil Nadu'} via NammaMap GIS.`,
    breadcrumbLabel: (p.sro_name || p.office_nam || '') as string
  };
};
